import { createContext } from 'react';

export const elementFieldPathHookContext = createContext<() => string>(() => {
  throw new Error('not in elementFieldPathHookContext');
});
